import { Text } from '@medly-components/core';
import styled from 'styled-components';

export const NoMatchFoundWrapper = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 4.8rem 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}) {
        padding: 6.4rem 0;
    }
`;

export const NoMatchFoundTitle = styled(Text).attrs({ textVariant: 'h4', textWeight: 'Medium' })`
    margin: 1.6rem 0 0.8rem;
`;

export const NoMatchFoundSubtitle = styled(Text)`
    color: ${({ theme }) => theme.colors.grey[700]};
`;
